/**
 * Chek landscape.
 *
 * @return {boolean}
 */
export const isLandscape = (): boolean => {

    return (window.orientation === 90 || window.orientation === -90);
};